import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ticketStatus',
    standalone: false
})
export class TicketStatusPipe implements PipeTransform {

  transform(value: any): any {
    switch (value) {
      case 1:
        return 'Partially';
      case 2:
        return 'Closed';
      default:
        return 'Open';
    }
  }

}
